import { PROJECT_STATUSES } from "@/app/projects/constants";
import isStatus from "./is-status";

export const isProjectProcessing = (project) =>
  isProjectStatus(project, "processing");

export const hasProjectSucceeded = (project) =>
  isProjectStatus(project, "succeeded");

export const hasProjectFailed = (project) => isProjectStatus(project, "failed");

export const hasProjectFinished = (project) =>
  isProjectStatus(project, "failed", "succeeded", "processed");

export const isProjectStatus = (project, ...expectations) =>
  isStatus(PROJECT_STATUSES, project, "status", ...expectations);
